import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardVariant, CardAuthor, CardTheme } from './card.types';

@Component({
    selector: 'app-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './card.component.html',
    styleUrl: './card.component.css',
    encapsulation: ViewEncapsulation.None
})
export class CardComponent {

    // ==================== VARIANTE Y ESTILO ====================

    /**
     * Variante visual de la card
     */
    @Input() variant: CardVariant = 'simple';

    /**
     * Tema de color de la card
     * - dark-blue: Fondo azul oscuro con texto blanco (usado en .caja)
     * - transparent-white: Fondo blanco transparente con borde (usado en .d)
     * - glass: Fondo blanco semi-transparente con borde (usado en whyCard, secCard)
     * - cyan-light: Fondo cyan claro con texto oscuro (usado en goal-card)
     * - white: Fondo blanco sólido con texto oscuro (usado en testimonial-card)
     * - custom: Usa el valor de customBackground
     */
    @Input() theme: CardTheme = 'dark-blue';

    /**
     * Color de fondo personalizado (solo funciona con theme='custom')
     * Acepta cualquier valor CSS válido: rgba(), #hex, rgb(), etc.
     */
    @Input() customBackground?: string;

    // ==================== CONTENIDO BÁSICO ====================

    /**
     * Título principal de la card (alternativa a slot)
     */
    @Input() title?: string;

    /**
     * Subtítulo de la card (alternativa a slot)
     */
    @Input() subtitle?: string;

    /**
     * Número decorativo (para variant 'number-title-body')
     */
    @Input() number?: string;

    /**
     * Clase de icono FontAwesome (ej: 'fa-solid fa-heart')
     */
    @Input() icon?: string;

    /**
     * URL de imagen (para variants con imagen)
     */
    @Input() image?: string;

    /**
     * Texto alternativo de la imagen
     */
    @Input() imageAlt?: string;

    /**
     * Título de la imagen (tooltip)
     */
    @Input() imageTitle?: string;

    /**
     * Texto del footer (alternativa a slot)
     */
    @Input() footerText?: string;

    // ==================== CONTENIDO ESPECIAL ====================

    /**
     * Información del autor (para testimonios)
     */
    @Input() author?: CardAuthor;
}
